import React from "react";
import styled from "styled-components/macro";
import { ButtonText } from "@loanbossinc/component-library";
import "./filterBarStyles.css";

const TopText = styled.span`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  align-items: center;
  text-transform: uppercase;
  color: #5F6368;
`;

const BottomText = styled.span`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
`;

const EDCWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4.5em;
`;

const EDCItem = styled.div`
  width: max-content;
`;

const GapWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2em;
`;

const DSB_DISABLED = "dsb-disabled";

const FilterSection = ({ disabledEditFilters, onExport: handleOnExportClicked, setFilterPanelIsOpen }) => (
  <div className="deal-screener-filter-bar-filters-wrapper">
    <ButtonText
      className={`deal-screener-buttons ${disabledEditFilters ? DSB_DISABLED : ""}`}
      label="Filters"
      iconName="tune"
      onClick={() => setFilterPanelIsOpen(true)}
      disabled={disabledEditFilters}
    />
    <ButtonText className="deal-screener-buttons" onClick={handleOnExportClicked} label="Export XLS" iconName="save_alt" />
  </div>
);

const EDCFilterBar = ({
  setFilterPanelIsOpen,
  onExport,
  disabledEditFilters,
  campaign,
  cancelCampaign,
  onContinueToCampaign: handleOnContinueToCampaignClicked,
  disabledContinueButtons
}) => (
  <div className="deal-screener-filter-bar-wrapper">
    <EDCWrapper>
      <EDCItem className="deal-screener-filter-bar-text-wrapper">
        <TopText>Email Engagement</TopText>
        <BottomText>{campaign.name}</BottomText>
      </EDCItem>
      <GapWrapper>
        <EDCItem className="deal-screener-filter-bar-text-wrapper">
          <ButtonText
            className="deal-screener-buttons-cancel"
            onClick={cancelCampaign}
            label="Cancel deal selection"
          />
        </EDCItem>
        <EDCItem className="deal-screener-filter-bar-text-wrapper">
          <ButtonText
            disabled={disabledContinueButtons}
            className={`${disabledContinueButtons && "dsb-disabled"} deal-screener-buttons`}
            onClick={handleOnContinueToCampaignClicked}
            label="Save and continue"
          />
        </EDCItem>
      </GapWrapper>
    </EDCWrapper>
    <FilterSection
      onExport={onExport}
      setFilterPanelIsOpen={setFilterPanelIsOpen}
      disabledEditFilters={disabledEditFilters}
    />
  </div>
);

const DealScreenerFilterBar = ({ numberOfDealsMessage, setFilterPanelIsOpen, onExport: handleOnExportClicked, disabledEditFilters }) => (
  <div className="deal-screener-filter-bar-wrapper">
    <div className="deal-screener-filter-bar-text-wrapper">{numberOfDealsMessage}</div>
    <FilterSection
      onExport={handleOnExportClicked}
      setFilterPanelIsOpen={setFilterPanelIsOpen}
      disabledEditFilters={disabledEditFilters}
    />
  </div>
);

const FilterBar = props => (
  (Object.keys(props.campaign).length === 0 && props.campaign.constructor === Object) ?
    <DealScreenerFilterBar {...props} /> :
    <EDCFilterBar {...props} />
);

export default FilterBar;
